import React from "react";
import "../../styles/MaintenancePage.css"
import maintenance from "../maintenance/maintenance_break.jpg";

const MaintenancePage = () => {
  return (
    <div className="maintenance-container">
      <img src={maintenance} alt="Maintenance" className="maintenance-image" />
      <div className="project-name">Portal</div>
    </div>
  );
}
export default MaintenancePage;
